import { useState } from 'react'
import { useAuth } from '../lib/AuthContext'
import { useLang } from '../lib/LangContext'
import AccesCaissier from './AccesCaissier'

export default function AuthPage({ onCaissierLogin }) {
  const { signIn, signUp, signInWithGoogle } = useAuth()
  const { t, lang } = useLang()
  const [tab, setTab] = useState('login')
  const [caissierMode, setCaissierMode] = useState(false)
  const [loading, setLoading] = useState(false)
  const [googleLoading, setGoogleLoading] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')
  const [loginData, setLoginData] = useState({ email: '', password: '' })
  const [registerData, setRegisterData] = useState({ nom: '', email: '', telephone: '', password: '' })

  function getGreeting() {
    const h = new Date().getHours()
    if (h < 12) return t('greeting_morning')
    if (h < 18) return t('greeting_afternoon')
    return t('greeting_evening')
  }

  async function handleLogin(e) {
    e.preventDefault()
    setLoading(true); setError('')
    const { error } = await signIn(loginData)
    if (error) setError(t('wrong_credentials'))
    setLoading(false)
  }

  async function handleRegister(e) {
    e.preventDefault()
    setLoading(true); setError('')
    if (registerData.password.length < 6) {
      setError(t('password_short')); setLoading(false); return
    }
    const { error } = await signUp(registerData)
    if (error) setError(error.message)
    else setSuccess(t('account_created'))
    setLoading(false)
  }

  async function handleGoogle() {
    setGoogleLoading(true); setError('')
    const { error } = await signInWithGoogle()
    if (error) { setError('Erreur avec Google. Réessaie.'); setGoogleLoading(false) }
  }

  if (caissierMode) {
    return <AccesCaissier onSuccess={onCaissierLogin} onBack={() => setCaissierMode(false)} />
  }

  return (
    <div className="auth-screen">
      <div className="auth-card">
        <div style={{ marginBottom: '0.25rem', fontSize: 12, color: 'var(--muted)' }}>{getGreeting()}</div>
        <div className="auth-logo">Stock<span>O</span></div>
        <div className="auth-tagline">{t('auth_tagline') || 'Gérez votre boutique depuis votre téléphone'}</div>

        {/* BOUTON GOOGLE */}
        <button className="btn-google" onClick={handleGoogle} disabled={googleLoading}>
          <svg width="18" height="18" viewBox="0 0 48 48">
            <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
            <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
            <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
            <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
          </svg>
          {googleLoading ? 'Redirection...' : t('continue_google')}
        </button>

        <div className="divider">{t('or')}</div>

        <div className="auth-tabs">
          <button className={`auth-tab ${tab === 'login' ? 'active' : ''}`}
            onClick={() => { setTab('login'); setError(''); setSuccess('') }}>
            {t('login')}
          </button>
          <button className={`auth-tab ${tab === 'register' ? 'active' : ''}`}
            onClick={() => { setTab('register'); setError(''); setSuccess('') }}>
            {t('register')}
          </button>
        </div>

        {tab === 'login' ? (
          <form onSubmit={handleLogin}>
            <div className="field">
              <label>{t('email')}</label>
              <input type="email" placeholder="boutique@email.com" required
                value={loginData.email} onChange={e => setLoginData({ ...loginData, email: e.target.value })} />
            </div>
            <div className="field">
              <label>{t('password')}</label>
              <input type="password" placeholder="••••••••" required
                value={loginData.password} onChange={e => setLoginData({ ...loginData, password: e.target.value })} />
            </div>
            <button type="submit" className="btn-primary" disabled={loading}>
              {loading ? t('connecting') : t('connect')}
            </button>
          </form>
        ) : (
          <form onSubmit={handleRegister}>
            <div className="field">
              <label>{t('shop_name')}</label>
              <input type="text" placeholder="Ex: Alimentation Chez Marie" required
                value={registerData.nom} onChange={e => setRegisterData({ ...registerData, nom: e.target.value })} />
            </div>
            <div className="field">
              <label>{t('email')}</label>
              <input type="email" placeholder="boutique@email.com" required
                value={registerData.email} onChange={e => setRegisterData({ ...registerData, email: e.target.value })} />
            </div>
            <div className="field">
              <label>{t('phone')}</label>
              <input type="tel" placeholder="+237 6XX XXX XXX"
                value={registerData.telephone} onChange={e => setRegisterData({ ...registerData, telephone: e.target.value })} />
            </div>
            <div className="field">
              <label>{t('password')}</label>
              <input type="password" placeholder="Minimum 6 caractères" required
                value={registerData.password} onChange={e => setRegisterData({ ...registerData, password: e.target.value })} />
            </div>
            <button type="submit" className="btn-primary" disabled={loading}>
              {loading ? t('creating') : t('create_account')}
            </button>
          </form>
        )}

        {error && <div className="error-msg">⚠ {error}</div>}
        {success && <div className="success-msg">✓ {success}</div>}

        {/* BOUTON ACCÈS CAISSIER */}
        <div style={{ marginTop: '1.25rem', paddingTop: '1.25rem', borderTop: '1px solid var(--cream-dark)' }}>
          <button onClick={() => setCaissierMode(true)} style={{
            width: '100%', padding: 11, background: 'var(--cream)',
            border: '1.5px solid var(--cream-dark)', borderRadius: 'var(--radius-md)',
            fontSize: 13, cursor: 'pointer', color: 'var(--charcoal)',
            fontFamily: 'DM Sans, sans-serif', display: 'flex',
            alignItems: 'center', justifyContent: 'center', gap: 8
          }}>
            🧑‍💼 {lang === 'fr' ? 'Accès caissier (PIN)' : 'Cashier access (PIN)'}
          </button>
          <div style={{ textAlign: 'center', fontSize: 11, color: 'var(--muted)', marginTop: 8 }}>
            {lang === 'fr' ? 'Vous êtes caissier ? Utilisez le PIN fourni par votre patron.' : 'Are you a cashier? Use the PIN provided by your owner.'}
          </div>
        </div>

        <div style={{ marginTop: '1rem', textAlign: 'center', fontSize: 11, color: 'var(--muted)' }}>
          {t('trial_info')}
        </div>
      </div>
    </div>
  )
}
